// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._6CLPm0HabTV7sxV84Ozw {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 570px;
    padding: 40px !important;

    @media (max-width: 576px) {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./Ui/PageNotAvailable/PageNotAvailable/PageNotAvailable.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,wBAAwB;;IAExB;QACI,WAAW;IACf;AACJ","sourcesContent":[".content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    width: 570px;\n    padding: 40px !important;\n\n    @media (max-width: 576px) {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `_6CLPm0HabTV7sxV84Ozw`
};
export default ___CSS_LOADER_EXPORT___;
